import * as yup from 'yup';

export const editProductSchema = yup.object().shape({
  titleAm: yup.string().required('Title is required'),
  titleEn: yup.string().required('Title is required'),
  titleRu: yup.string().required('Title is required'),
  visible: yup.string().required(),
  brand: yup.string().required('Brand is required.'),
  descriptionEn: yup.string()
    .optional()
    .max(250, 'Description must be 250 characters or fewer.')
    .nullable(),
  descriptionRu: yup.string()
    .optional()
    .max(250, 'Description must be 250 characters or fewer.')
    .nullable(),
  descriptionAm: yup.string()
    .optional()
    .max(250, 'Description must be 250 characters or fewer.')
    .nullable(),
});
